export enum DeleteWeekTransactionsKeys {
  week = 'week',
  year = 'year',
}

export interface DeleteWeekTransactions {
  [DeleteWeekTransactionsKeys.week]: string;
  [DeleteWeekTransactionsKeys.year]: string;
}
